function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
	var img = new Image()
	img.crossOrigin = 'anonymous'
	img.onload = function() {
		var canvas = document.createElement('CANVAS')
		var ctx = canvas.getContext('2d')
		var dataURL
		canvas.height = this.height
		canvas.width = this.width
		ctx.drawImage(this, 0, 0)
		dataURL = canvas.toDataURL(outputFormat)
		callback(dataURL)
		canvas = null
	}
	img.src = url
}

function convertFileToDataURLviaFileReader(url, callback) {
	var xhr = new XMLHttpRequest()
	xhr.onload = function() {
		var reader = new FileReader()
		reader.onloadend = function() {
			callback(reader.result)
		}
		reader.readAsDataURL(xhr.response)
	}
	xhr.open('GET', url)
	xhr.responseType = 'blob'
	xhr.send()
}

function base64ToBlob(base64, mimeType = 'image/png') {
	const byteChars = atob(base64)
	const byteNumbers = new Array(byteChars.length)

	for (let i = 0; i < byteChars.length; i++) {
		byteNumbers[i] = byteChars.charCodeAt(i)
	}

	return new Blob([new Uint8Array(byteNumbers)], { type: mimeType })
}

export {
	convertImgToDataURLviaCanvas,
	convertFileToDataURLviaFileReader,
	base64ToBlob,
}
